import { useState } from 'react'

import axios from 'axios'
import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'
import InputField from 'components/Form/InputField/InputField'
import { addToast } from 'components/Toast/Toast'
import { sendPasswordResetEmail } from 'services/endpoints/auth'

interface RecoverAccountProps {
    id?: string
    email?: string
    title?: string
    setActivePanel?: any
    fromSubscribeModal?: boolean
}

export const RecoverAccount = ({
    email,
    title,
    setActivePanel,
    fromSubscribeModal = false
}: RecoverAccountProps) => {
    const [recoverData, setRecoverData] = useState<string>(email ?? '')
    const [recoverAttempted, setRecoverAttempted] = useState<boolean>(false)
    const [isValid, setIsValid] = useState<boolean>(false)

    const { t } = useTranslation()

    const submitForm = async () => {
        if (!isValid) {
            addToast('error', t('error:errorInvalidDataEntered'))
            return false
        }
        try {
            await sendPasswordResetEmail({
                email: recoverData
            })
            addToast('success', t('passwordResetLinkEmail'), 4000)
        } catch (error) {
            setRecoverAttempted(true)
            if (axios.isAxiosError(error)) {
                addToast(
                    'error',
                    error?.response?.data?.errors?.email?.[0] ??
                        error?.response?.data?.message ??
                        t('error:errorInvalidEmail')
                )
                return false
            }
            addToast('error', t('error:errorSendingEmail'))
        }
    }

    return (
            <div
                className={`auth-recover ${
                    fromSubscribeModal
                        ? 'auth-recover--subscribe-modal'
                        : ''
                }`}
            >
                <h1 className='auth-recover__title'>
                    {title ?? t('forgotPassword')}
                </h1>

                <p className='auth-recover__text'>{t('ifYouHaveAnAccount')}</p>

                <div className='auth-recover__form'>
                    <InputField
                        id='recover-email'
                        type='email'
                        validate='required|email'
                        validationCheck={(invalid: boolean) => {
                            setIsValid(!invalid)
                        }}
                        value={recoverData}
                        changeFn={(val: string) => {
                            setRecoverAttempted(false)
                            setRecoverData(val)
                        }}
                        additionalProps={{
                            placeholder: `${t('email')} / ${t('phoneNumber')}`
                        }}
                        loginAttempted={recoverAttempted}
                    />

{/*                     <p className='auth-recover__help'>
                        {t('stillHavingTroubles')} <span>{t('clickHere')}</span>
                    </p> */}

                    <div className='auth-recover__buttons'>
                        <Button
                            text={t('send')}
                            color='blue'
                            font='mont-15-semi-bold'
                            width='100'
                            height='5'
                            clickFn={async () => await submitForm()}
                        />
                        <Button
                            text={t('cancel')}
                            color='transparent'
                            type='transparent--black'
                            font='mont-15-semi-bold'
                            width='100'
                            height='5'
                            clickFn={() => {
                                if (setActivePanel) {
                                    setActivePanel('login')
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
    )
}
